import { Module } from "vuex";
import { State } from "@/store/modules/stand/state";
import Mutations from "@/store/modules/stand/mutations";
import Getters from "@/store/modules/stand/getters";
import Actions from "@/store/modules/stand/actions";

export class Stand implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
